import styled from "styled-components";

export const ExercisePartList = styled.ul`
  gap: 8px;
  display: flex;
  flex-direction: column;
`;
